import axios from "axios";

//LIVE
export const appBaseURL = `https://apis.locwire.com/`    
console.log = function () { };

//DEV
// export const appBaseURL = `https://devapi.locwire.com/`

//LOCAL
// export const appBaseURL = `//192.168.0.25:3000/` 

const Api = () => axios.create({
    baseURL: appBaseURL
});

export const env = "prod"

export const Alert = (message, type,) => {
    let div = document.createElement('div');
    div.classList.add("custom_alert")
    div.classList.add(type)
    div.innerHTML += `<p>${message}</p>`
    document.body.append(div)
    setTimeout(() => {
        document.body.querySelector(".custom_alert").remove()
    }, 4000);
}

export const isLogIn = () => {
    if (localStorage.getItem('LW_TOKEN')) {
        return { isToken: true, token: localStorage.getItem('LW_TOKEN') };
    } else {
        return { isToken: false, token: '' };
    }
};

const headers = () => {
    if (isLogIn().token) {
        return {
            headers: {
                "token": isLogIn().token,
            }
        }
    } else {
        return {
            headers: {}
        }
    }
}

//Handle API response
function handleResponse(response) {
    if (response.status === 200 || response.status === 201) {
        return response
    }
    if (response.status === 500 || response.status === 404) {
        return { response: { data: { error: response.data.error } }, error: true }
    }
    else {
        return { response: { data: { error: response.data.error } }, error: true }
    }
}


let errorData = (err) => {
    return {
        error: err.response && err.response.data ?
            (typeof err.response.data.error == "string" ?
                err.response.data.error : err.response.data.error?.message) : "Something went wrong"
    }
}
// const tokenError = (err) => {
//     if (err.response?.data.errorCode === "TOKEN_EXPIRED" || err.response?.data.error === "Session Expired" || err.response?.data.error === "jwt expired" || err.response?.data.errorCode === "USER_NOT_EXIST") {
//         setTimeout(() => {
//             localStorage.removeItem("LW_TOKEN")
//             // window.location.reload(false);
//         }, 2000);
//         // window.open("/login", "_self") 
//     }
// }
const tokenError = (err) => {
    const errorCode = err.response?.data?.errorCode;
    const errorMsg = err.response?.data?.error;

    const isTokenError =
        errorCode === "TOKEN_EXPIRED" ||
        errorCode === "User not found" ||
        errorMsg === "Session Expired" ||
        errorMsg === "jwt expired" ||
        errorCode === "USER_NOT_EXIST";

    if (isTokenError) {
        // Clear token and redirect to login
        localStorage.removeItem("LW_TOKEN");

        // Optionally add a delay if needed
        setTimeout(() => {
            window.location.href = "/login"; // this replaces window.open
        }, 1000); // slight delay for UX if needed
    }
};



//API methods Admin
export const GetApiPublic = (url) => {
    return Api().get(url, { headers: {} }).then(handleResponse).catch((err) => {
        tokenError(err)
        return {
            error: true,
            response: {
                data: errorData(err)
            },
            res: err.response || "Something went wrong"
        }
    })
}
export const GetApi = (url) => {
    return Api().get(url, headers()).then(handleResponse).catch((err) => {
        tokenError(err)
        return {
            error: true,
            response: {
                data: errorData(err)
            },
            res: err.response || "Something went wrong"
        }
    })
}
export const PostApi = async (url, body) => {
    return Api().post(url, body, headers()).then(handleResponse).catch((err) => {
        tokenError(err)
        return {
            error: true,
            response: {
                data: errorData(err)
            },
            res: err.response || "Something went wrong"
        }
    })
}
export const PutApi = async (url, body) => {
    return Api().put(url, body, headers()).then(handleResponse).catch((err) => {
        tokenError(err)
        return {
            error: true,
            response: {
                data: errorData(err)
            },
            res: err.response || "Something went wrong"
        }
    })
}
export const DeleteApi = async (url) => {
    return Api().delete(url, headers()).then(handleResponse).catch((err) => {
        tokenError(err)
        return {
            error: true,
            response: {
                data: errorData(err)
            },
            res: err.response || "Something went wrong"
        }
    })
}